import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_NODE_API;

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("authToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const eventService = {
  getPublicEvents: async (params = {}) => {
    try {
      const { page = 1, perPage = 12, ...queryParams } = params;

      const endpoint = `events/getall/${page}/${perPage}`;

      const response = await api.get(endpoint, { params: queryParams });

      const responseData = response.data?.data || {};

      return {
        data: responseData.events || [],
        total: responseData.total || 0,
        totalPages: responseData.totalPages || 1,
        currentPage: responseData.currentPage || page,
        hasMore: responseData.hasMore || false,
      };
    } catch (error) {
      // console.error("getPublicEvents error:", error);
      // throw error;
    }
  },

  getEventById: async (eventId) => {
    try {
      const response = await api.get(`/events/${eventId}`);
      return response.data;
    } catch (error) {
      // console.error("Error fetching event details:", error);
      // throw error;
    }
  },

  checkUserInterest: async (eventId) => {
    try {
      const response = await api.get(`/events/${eventId}/interest-status`);
      return response.data;
    } catch (error) {
      // console.error("Error checking user interest:", error);
      // throw error;
    }
  },

  expressInterest: async (eventId, contactInfo) => {
    try {
      const response = await api.post(
        `/events/${eventId}/interest`,
        contactInfo
      );
      return response.data;
    } catch (error) {
      // console.error("Error expressing interest:", error);
      // throw error;
    }
  },

  getUserInterestedEvents: async () => {
    try {
      const response = await api.get("/events/user/interested");
      return response.data;
    } catch (error) {
      // console.error("Error fetching interested events:", error);
      // throw error;
    }
  },

  removeInterest: async (eventId) => {
    try {
      const response = await api.delete(`/events/${eventId}/interest`);
      return response.data;
    } catch (error) {
      // console.error("Error removing interest:", error);
      // throw error;
    }
  },

  getCategories: async () => {
    try {
      const response = await api.get("/events/categories");
      return response.data;
    } catch (error) {
      // console.error("Error fetching categories:", error);
      // throw error;
    }
  },
};

export default eventService;
